const state = () => ({
  graphVisitAgency: [],
  graphMissionTarget: [],
  graphVisitSales: []
})

const mutations = {
  getGraphVisitAgency: (state, data) => {
    return (state.graphVisitAgency = data)
  },

  getGraphMissionTarget: (state, data) => {
    return (state.graphMissionTarget = data)
  },

  getGraphVisitSales: (state, data) => {
    return (state.graphVisitSales = data)
  }
}

const actions = {
  getGraphVisitAgency({ commit }, { shop_id, user_id }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('shop_id', shop_id)
      fommData.append('user_id', user_id)
      fetch(`${window.baseAPINew}/web/?act=graph_visit_agency`, {
        method: 'POST',
        body: fommData
      })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          commit('getGraphVisitAgency', result)
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getGraphMissionTarget({ commit }, { shop_id, user_id }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('shop_id', shop_id)
      fommData.append('user_id', user_id)
      fetch(`${window.baseAPINew}/web/?act=graph_miss_target`, {
        method: 'POST',
        body: fommData
      })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          commit('getGraphMissionTarget', result)
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  getGraphVisitSales({ commit }, { shop_id, user_id }) {
    return new Promise((resolve, reject) => {
      const fommData = new FormData()
      fommData.append('shop_id', shop_id)
      fommData.append('user_id', user_id)
      fetch(`${window.baseAPINew}/web/?act=graph_visit_sales`, {
        method: 'POST',
        body: fommData
      })
        .then((response) => {
          return response.json()
        })
        .then((result) => {
          commit('getGraphVisitSales', result)
          resolve(result)
        })
        .catch((error) => {
          reject(error)
        })
    })
  }
}

const getters = {}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
